import React, { CSSProperties, PropsWithChildren } from 'react';

import './OverlayPanel.scss';
import classNames from 'classnames';

type OverlayPanelProps = PropsWithChildren<{
    className?: string;
    height?: number;
    top?: number;
}>;

export default function OverlayPanel(props: OverlayPanelProps) {
    const { className, children, height, top } = props;

    const cssClasses = classNames('OverlayPanel', className);

    const style: CSSProperties = {};
    if (height) {
        style.height = height;
    }
    const childStyles = { ...style };
    if (top) {
        style.top = top;
    }

    return (
        <div className={cssClasses} style={style}>
            <div className="background" style={childStyles} />
            <div className="overlay" style={childStyles}>
                {children}
            </div>
        </div>
    );
}
